import { render, staticRenderFns } from "./CheckoutShippingAdd.vue?vue&type=template&id=b89731ae&"
import script from "./CheckoutShippingAdd.vue?vue&type=script&lang=js&"
export * from "./CheckoutShippingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports